import { useState } from 'react';
import { GenerateParams, UseQnaAutoReplyReturnType } from '../../types/qna/aiReply';
import { fetchAIGeneratedReply, handleAIReplyError } from '../../lib/utils/qnaUtils';
import useToastMsg from '../common/useToastMsg';
import qnaToastMsg from '../../constants/service/toastMsg/qnaToastMsg';

/**
 * AI 답변 자동완성 커스텀 훅
 * OpenAI 파인튜닝 모델을 사용하여 고객 문의에 대한 답변을 자동으로 생성합니다.
 *
 * @returns {UseQnaAutoReplyReturnType} generate 함수와 isLoading 상태
 */
export const useQnaAutoReply = (): UseQnaAutoReplyReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToastMsg();

  const generate = async (params: GenerateParams): Promise<string | null> => {
    setIsLoading(true);

    try {
      const reply = await fetchAIGeneratedReply(params);
      toast.success(qnaToastMsg.AI_REPLY_GENERATE_SUCCESS);
      return reply;
    } catch (err) {
      const errorMessage = handleAIReplyError(err);
      toast.error(errorMessage);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    generate,
    isLoading,
  };
};
